export const UX_COPY_BN = {
  "quickNavAria": "পৃষ্ঠা বিভাগে দ্রুত লিঙ্ক",
  "skipToSections": "বিভাগ মেনুতে যান",
  "jumpToStudioHint": "শর্টকাট: Alt + S"
};

export const TRIAL_FLOW_COPY_BN = {
  "flowLabel": "এটা কিভাবে কাজ করে",
  "flowSteps": [
    "দ্রুত পরীক্ষা চালানোর জন্য একটি ছবি বেছে নিন।",
    "আপনার নির্বাচিত মার্কেটপ্লেসের সাথে Metadata Studio এ চালিয়ে যান।",
    "রপ্তানির আগে ফলাফল পর্যালোচনা এবং সম্পাদনা করুন।"
  ]
};

export const LANDING_SALES_COPY_BN = {};


export default LANDING_SALES_COPY_BN;
